import { ScriptTopPostView } from "@features/aiScriptGeneration/lib/deriveContentAnalysis";
import { Typography } from "@shared/ui";
import React from "react";
import viewStyles from "./CreatorInsightsView.module.scss";
import styles from "./TopPerformingContent.module.scss";

const { Text } = Typography;

export function TopPerformingContent({ posts }: { posts: ScriptTopPostView[] }) {
  if (!posts.length) return null;

  return (
    <div className={viewStyles.section}>
      <Text className={viewStyles.heading}>Top performing content</Text>
      <ul className={styles.posts}>
        {posts.map((post) => (
          <li key={post.key} className={styles.post}>
            {post.url ? (
              <a className={styles.title} href={post.url} target="_blank" rel="noreferrer">
                {post.title}
              </a>
            ) : (
              <span className={styles.title}>{post.title}</span>
            )}
            <div className={styles.metrics}>
              {post.viewsLabel ? <span>{post.viewsLabel} views</span> : null}
              {post.viewsLift ? <span>{post.viewsLift}</span> : null}
              {post.erLabel ? <span>ER {post.erLabel}</span> : null}
              {post.erLift ? <span>{post.erLift}</span> : null}
            </div>
            {post.description ? <p className={styles.description}>{post.description}</p> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
